import { render, staticRenderFns } from "./edit-site-plans.vue?vue&type=template&id=8148a90a&scoped=true"
import script from "./edit-site-plans.vue?vue&type=script&lang=js"
export * from "./edit-site-plans.vue?vue&type=script&lang=js"
import style0 from "./edit-site-plans.vue?vue&type=style&index=0&id=8148a90a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8148a90a",
  null
  
)

export default component.exports